import {addLoadingScreen, EXTRA_SCREEN, PLAY_SCREEN, removeLoadingScreen} from './duck-screen';
import {setUnlockLimitsForExtraLevels} from './duck-game';
import {fsAppConfig,} from "../firestore";
import {addReducerParametersToError, CRASH_ERROR, sendError} from "../middleware/middleware-error-handler";
import {setImageServers} from "../helpers/cloud-function/riddle-image";
import {isAndroid, isIOS} from "../helpers/mobile";

export const SAVE_APP_CONFIG = "SAVE_APP_CONFIG";

/* Wszystkie asynchroniczne funkcje */

/**
 * Funkcja wywoływana przy starcie aplikacji
 * config/appConfig
 */
export function fetchFsConfig(){
	return dispatch => {
		dispatch(addLoadingScreen('loading_config', [PLAY_SCREEN, EXTRA_SCREEN]));
		fsAppConfig.get()
			.then(doc => {
				const config = doc.data();
				// const error = Error(`pobieranie błąd configu`)
				// addParametersToErrorIfNotPresent(error, "", JSON.stringify(config))
				// throw error;

				dispatch(saveAppConfig(config));
				dispatch(setUnlockLimitsForExtraLevels(config.gameTypesProperties));

				if(config && config.strings){
					setImageServers(config.strings.imgServerUrl, config.strings.imgSolvedServerUrl)
				}
			})
			.catch(error=> {
				console.log(error);
				debugger;
				dispatch(sendError(error, CRASH_ERROR, 'error_config_download_error'));
			})
			.then(() => {
				dispatch(removeLoadingScreen('loading_config'));
			})
	}
}

/* Wszystkie synchroniczne action creators */

/**
 * Zapisuje config do stanu aplikacji
 * @param config - obiekt z dokumentu appConfig
 */
export function saveAppConfig(config){
	return {
		type: SAVE_APP_CONFIG,
		payload: {
			config
		}
	}
}

export const defaultState = {
	appConfig: {
		booleans: {},
		keys: {},
		strings: {
			facebookUrl: ''
		},
		gameTypesProperties: {

		}
	},
	deviceConfig: {
		isDeviceAndroid: isAndroid(),
		isDeviceIOS: isIOS(),
	}
};


export default function(state = defaultState, action) {
	try{
		switch (action.type) {
			case SAVE_APP_CONFIG:
				return Object.assign({}, { ...state }, { appConfig: action.payload.config });
			default:
				return state;
		}
	} catch (error){
		addReducerParametersToError(error, "error_config_reducer", action, state);
		throw error
	}
}
